import React from 'react'
import {Icon} from '@chakra-ui/react'

const PlayIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_31_664)">
                <circle cx="20" cy="20.0001" r="20" fill="white" />
                <path
                    d="M27.5 19.1341C28.1667 19.519 28.1667 20.4812 27.5 20.8661L17 26.9283C16.3333 27.3132 15.5 26.8321 15.5 26.0623L15.5 13.9379C15.5 13.1681 16.3333 12.687 17 13.0719L27.5 19.1341Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_31_664">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default PlayIcon
